export function animationOnScroll() {
    let $window = $(window);
    let $items = $(".has-animation");
    let addClass = () => {
        $items.each(function (_i, it) {
            if (
                $window.scrollTop() > $(it).offset().top - $window.height() * 0.95 &&
                !$(it).hasClass("animate")
            ) {
                $(it).addClass("animate");
            }
        });
    };

    $(window).on("scroll load", function (event) {
        addClass();
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/animationOnScroll.js